<ul class="left-column">
    <li class="validation-message-item">
        <span
            [class.bullet-valid]="
                control.isDirtyOrTouched && !control.formControl.errors?.minlength
            "
            class="validation-message-item-bullet"
        >
        </span>
        <span class="validation-message-text">{{ validationMessages.minlength }}</span>
    </li>
    <li class="validation-message-item">
        <span
            [class.bullet-valid]="
                control.isDirtyOrTouched && !control.formControl.errors?.min1Number
            "
            class="validation-message-item-bullet"
        >
        </span>
        <span class="validation-message-text">{{ validationMessages.min1Number }}</span>
    </li>
</ul>
<ul class="right-column">
    <li class="validation-message-item">
        <span
            [class.bullet-valid]="
                control.isDirtyOrTouched && !control.formControl.errors?.min1Lowercase
            "
            class="validation-message-item-bullet"
        >
        </span>
        <span class="validation-message-text">{{ validationMessages.min1LowercaseCharacter }}</span>
    </li>
    <li class="validation-message-item">
        <span
            [class.bullet-valid]="
                control.isDirtyOrTouched && !control.formControl.errors?.min1SymbolOrUppercase
            "
            class="validation-message-item-bullet"
        >
        </span>
        <span class="validation-message-text">{{
            validationMessages.min1SymbolOrUppercaseCharacter
        }}</span>
    </li>
</ul>
